import React from 'react';
import { Form } from 'react-bootstrap';

interface Props {
	checked: boolean;
	onChange: (checked: boolean) => void;
	className?: string;
}

const MarkComplete = ({ checked, onChange, className = 'mb-4' }: Props) => {
	return (
		<div
			className={`py-2 px-3 rounded d-inline-block bg-ltGrey border-dkGrey text-black ${className}`}
			style={{ borderWidth: 1, borderStyle: 'solid' }}
		>
			<Form.Check
				type='checkbox'
				label='Mark this section as complete or not applicable'
				checked={checked}
				onChange={(e) => onChange(e.target.checked)}
				className='mb-0 mark-complete-check'
			/>
		</div>
	);
};

export default MarkComplete;
